import React from "react";
import { ConsoleRouteMap } from "./routes";
import { useAuth } from "../../../shared/context/auth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import FullPageLoaderWithPortal from "shared/components/loader";
import { AuthorityProvider, processApiForConsole } from "context/authority";
import { useEntity } from "../context/entity";
import { useGetSideFilterConfig } from "../hooks/useSideFilters/dataloader";
import SetSentryContext from "shared/sentry";
import { ConsoleStaticDataContextProvider } from "../context/consoleStaticData";
import Layout from "../components/layout";

/**
 * Wrapper around all authenticated Routes in Console.
 * Define any global context provide, navigation(SideNav,header etc) here
 */
function LoadSideFilters(props: { children: React.PropsWithChildren<any> }) {
  const { data } = useGetSideFilterConfig();
  if (data) {
    return <React.Fragment>{props.children}</React.Fragment>;
  }
  return null;
}
export default function AppWrapper() {
  const auth = useAuth();
  const location = useLocation();
  const { eventSeriesId } = useEntity();
  if (!auth.isLoggedIn()) {
    return <Navigate to={ConsoleRouteMap.LOGIN.path} state={{ from: location }} replace />;
  }

  return (
    <React.Fragment>
      <React.Suspense fallback={<FullPageLoaderWithPortal isLoading />}>
        <AuthorityProvider contextId={eventSeriesId} processApiData={processApiForConsole}>
          <ConsoleStaticDataContextProvider>
            <LoadSideFilters>
              <SetSentryContext />
              <Layout.Header />
              <Outlet />
            </LoadSideFilters>
          </ConsoleStaticDataContextProvider>
        </AuthorityProvider>
      </React.Suspense>
    </React.Fragment>
  );
}
